// extracted by mini-css-extract-plugin
module.exports = {"projects":"ProjectsShowcase_projects__3sP_s","showcase":"ProjectsShowcase_showcase__2HkOG","photo":"ProjectsShowcase_photo__1qSoG"};